export const createConfigWall = (name, wall) => {
    return {
        wall: name,
        pathIngresar: wall.pathIngresar,
        pathRegistracion: wall.pathRegistracion,
        idCookiePremium: wall.cookiePremium,
        favicon: wall.favicon,
        defaultRedirectUrl: wall.defaultRedirectUrl,
    };
}


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/helpers/wallData.js